import F1_LOADINGGIF from './gifs/f1_loading.gif';

export default { F1_LOADINGGIF };
